var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 22,
    height: 18
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1275 2.03888C20.3506 2.37403 19.5051 2.61525 18.6342 2.70919C19.5384 2.17202 20.2155 1.32337 20.5385 0.322471C19.69 0.827209 18.7605 1.18114 17.7912 1.36857C17.3861 0.935468 16.8961 0.590444 16.3518 0.35499C15.8075 0.119537 15.2206 -0.00129945 14.6275 1.05381e-05C12.2281 1.05381e-05 10.2984 1.94493 10.2984 4.33165C10.2984 4.66681 10.3391 5.00196 10.4051 5.32442C6.8123 5.13653 3.60801 3.42013 1.47773 0.792198C1.08958 1.45519 0.886167 2.21008 0.888672 2.97833C0.888672 4.48146 1.65293 5.80685 2.81836 6.58634C2.13155 6.55929 1.46083 6.37051 0.860742 6.03536V6.08868C0.860742 8.19356 2.34863 9.9379 4.33164 10.3391C3.95931 10.4358 3.57629 10.4853 3.1916 10.4863C2.90977 10.4863 2.64316 10.4584 2.37402 10.4203C2.92246 12.1367 4.51953 13.3834 6.42129 13.424C4.9334 14.5895 3.06973 15.275 1.04609 15.275C0.683008 15.275 0.347852 15.2623 0 15.2217C1.91953 16.4531 4.19707 17.1641 6.6498 17.1641C14.6123 17.1641 18.9693 10.5676 18.9693 4.842C18.9693 4.65411 18.9693 4.46622 18.9566 4.27833C19.7996 3.66134 20.5385 2.89708 21.1275 2.03888Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -2,
    y: -4,
    width: 26,
    height: 26,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.4a39a78d6261ac0c2b2fe32f68bccabc.svg";
export { ForwardRef as ReactComponent };